import { Box, Flex, useColorMode } from "@chakra-ui/react";
import * as React from "react";
import { Header } from "./components/Header";
import {
  OkHiIncomingMessageProvider,
  useOkHiIncomingMessage,
} from "./components/OkHiIncomingMessageProvider";
import { useLoadMap } from "./hooks/useLoadMap";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { LoadingApp } from "./components/LoadingApp";
import { PlaceInputScreen } from "./components/PlaceInputScreen";
import { AddressStateProvider } from "./components/AddressStateProvider";
import { MapScreen } from "./components/MapScreen";
import { StreetviewScreen } from "./components/StreetviewScreen";
import { ToTheDoorScreen } from "./components/ToTheDoorScreen";
import { QueryClient, QueryClientProvider } from "react-query";

import "focus-visible/dist/focus-visible";
import { ThemeProvider } from "./components/ThemeProvider";
import { useOkHiMessageSender } from "./hooks/useOkHiMessageSender";

const queryClient = new QueryClient();

export function App() {
  const { isLoaded } = useLoadMap();
  const { sendMessage } = useOkHiMessageSender();
  React.useEffect(() => {
    try {
      const deviceId = localStorage.getItem("okhi-device-id");
      sendMessage({
        type: "deviceId",
        deviceId: deviceId ?? undefined,
      });
    } catch (error) {
      sendMessage({
        type: "deviceId",
        deviceId: undefined,
      });
    }
  }, [sendMessage]);
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AddressStateProvider>
          <OkHiIncomingMessageProvider>
            <ThemeProvider>
              <Flex direction="column" h="100%">
                <Header />
                <Box flex={1}>{!isLoaded ? <LoadingApp /> : <Home />}</Box>
              </Flex>
            </ThemeProvider>
          </OkHiIncomingMessageProvider>
        </AddressStateProvider>
      </Router>
    </QueryClientProvider>
  );
}

function Home() {
  const { setColorMode } = useColorMode();
  const okhiMessage = useOkHiIncomingMessage();
  React.useEffect(() => {
    setColorMode(okhiMessage?.context.isDarkMode ? "dark" : "light");
  }, [okhiMessage?.context.isDarkMode, setColorMode]);
  return (
    <Switch>
      <Route path="/place-input">
        <PlaceInputScreen />
      </Route>
      <Route path="/map">
        <MapScreen />
      </Route>
      <Route path="/streetview">
        <StreetviewScreen />
      </Route>
      <Route path="/to-the-door">
        <ToTheDoorScreen />
      </Route>
      <Route path="/loading">
        <LoadingApp />
      </Route>
    </Switch>
  );
}
